import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { useId } from 'react';
import { LayoutCluster, LayoutStack } from '../layouts';
import styles from './Fieldset.module.css';
import { FieldsetLegendProps, FieldsetProps } from './types';
function FieldsetLegend(t0) {
  const $ = _c(13);
  const {
    className,
    hint,
    required,
    children
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = classNames(className, styles.legend);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== required) {
    t2 = required && <span aria-label="(required)">*</span>;
    $[2] = required;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== children || $[5] !== t2) {
    t3 = <span className={styles.groupLabel}>{children}{t2}</span>;
    $[4] = children;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== hint) {
    t4 = hint ? <span className={styles.groupHint}>{hint}</span> : null;
    $[7] = hint;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t3 || $[11] !== t4) {
    t5 = <legend className={t1}>{t3}{t4}</legend>;
    $[9] = t1;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  return t5;
}
function Fieldset({
  children,
  classNames: externalStyles,
  legend,
  legendSize = 'small',
  hint,
  required,
  error,
  layout = 'horizontal',
  layoutProps = {
    space: 'none'
  },
  errorDisplay = 'all',
  invisibleLegend,
  ...props
}: FieldsetProps) {
  const layoutClasses = classNames(styles.fieldContainer, layoutProps?.className, {
    [styles.groupError!]: !!error && errorDisplay !== 'text'
  });
  const Layout = layout === 'vertical' ? LayoutStack : LayoutCluster;
  const generatedId = useId();
  const id = props.id || generatedId;
  const errorId = error ? `${id}-error` : undefined;
  return <fieldset id={id} className={classNames(styles.fieldset, externalStyles?.fieldset)} aria-describedby={errorId} {...props}>
      {legend || hint ? <FieldsetLegend required={required} hint={hint} className={classNames(externalStyles?.legend, {
      [styles.legendMedium!]: legendSize === 'medium',
      [styles.invisibleLegend!]: invisibleLegend
    })}>
          {legend}
        </FieldsetLegend> : null}
      <Layout className={layoutClasses} {...layoutProps}>
        {children}
      </Layout>
      {error && errorDisplay !== 'border' ? <p id={errorId} className={styles.errorMessage} aria-live="polite" role="alert">
          {error}
        </p> : null}
    </fieldset>;
}
export default Fieldset;